/**
 * 화면 구현
 */
import { SbsPlayerGlobal } from '../../common';

customElements.define(
  'sbs-player-toparea-login',
  class extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        this.innerHTML = `
        <a role="button" href="javascript:void(0);" class="btnBorderType-login" aria-label="로그인" title="로그인" style="cursor: pointer;">로그인</a>
      `;
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      this.addEventListener('click', (event) => {
        const LOGIN_URL =
          `https://join.sbs.co.kr/login/login.do?div=pc_login&returnUrl=` +
          encodeURIComponent(location.href);

        window.location.href = LOGIN_URL;
      });
    }
  }
);
